import React, { useState, useEffect } from 'react';
import Prepaid from './Prepaid';
import {TransactionsList}  from "./TransactionList/TransactionList"
import actions from '../../redux/indicore/actions';
import { useDispatch, useSelector } from "react-redux";


export default function Dashboard() {
  const [currentView, setCurrentView] = useState('dashboard'); // 'dashboard' | 'all-transactions' | 'transaction-detail'
  const [selectedTransaction, setSelectedTransaction] = useState(null);
   const profileData = useSelector(state => state.authReducer.profileData);

  const { allTransactions= []} =
      useSelector((state) => state?.indicoreReducer || {});
  
      console.log("allTransactionsin dashboard", allTransactions);
  
    const dispatch = useDispatch();
    useEffect(() => {
      if(profileData?.orgId){
      dispatch(actions.getAllTransaction(profileData.orgId));
      }
    }, [dispatch,profileData?.orgId]);
  
  

  const handleViewChange = (view, transaction) => {
    setCurrentView(view);
    if (transaction) {
      setSelectedTransaction(transaction);
    }
  };

  // Transaction detail view


  // All transactions list
  if (currentView === 'all-transactions') {
    return (
      <TransactionsList
      allTransactions = {allTransactions?.data || []}
        onViewChange={handleViewChange}
      />
    );
  }

  // Default = Dashboard
  return (
    <Prepaid

      onViewChange={handleViewChange}
    />
  );
}
